import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import moment from 'moment';
import withNotify from '../../common/withNotify';
import withGoBack from '../../common/withGoBack';
import {
  onGoBack
} from '../../common/globals';
import withLoader from '../../common/withLoader';
import withOnline from '../../common/withOnline';
import withSetsSearch from '../../common/withSetsSearch';
import withOfficeSetsFilter from '../../common/withOfficeSetsFilter';
import Header from '../../components/Header';
import {
  initAPIController,
  getBackorders
} from '../../utils/utils';
import Bugsnag from '../../helpers/bugsnag';
import BackordersCaseTypes from '../../components/ManageCase/BackordersCaseTypes';
import BackordersAccounts from '../../components/ManageCase/BackordersAccounts';
import BackordersProducts from '../../components/ManageCase/BackordersProducts';
import InfoIcon from '../../assets/images/info.png';

class Backorders extends Component {
  constructor(props) {
    super(props);
    this.state = {
      updatedAt: '',
      accounts: [],
      backorders: [],
      selectedCaseType: [],
      isCaseType: false,
      selectedAccount: [],
      isAccount: false,
      selectedProduct: [],
      isProduct: false,
      isInfo: false,
      noRecords: true
    };
    this.apiController = null;
  }

  _onGoBack = () => {
    try {
      const { goBack, setGoBack } = this.props;
      goBack.push(window.location.pathname);
      setGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onAccountClick = () => {
    try {
      this.setState({ isAccount: true });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onCaseTypeClick = () => {
    try {
      this.setState({ isCaseType: true });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onProductClick = () => {
    try {
      this.setState({ isProduct: true });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSelectedAccount = (selection) => {
    try {
      this.setState((prevState) => ({
        selectedAccount: [...prevState.selectedAccount, selection],
        isAccount: false
      }), () => {
        this._onBackordersSearch();
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSelectedCaseType = (selection) => {
    try {
      this.setState((prevState) => ({
        selectedCaseType: [...prevState.selectedCaseType, selection],
        isCaseType: false
      }), () => {
        this._onBackordersSearch();
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSelectedProduct = (selection) => {
    try {
      this.setState((prevState) => ({
        selectedProduct: [...prevState.selectedProduct, selection],
        isProduct: false
      }), () => {
        this._onBackordersSearch();
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onGoBackSetInfo = () => {
    try {
      const { goBack } = this.props;
      onGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onBackordersBack = () => {
    try {
      this.setState({
        isCaseType: false,
        isAccount: false,
        isProduct: false,
        isInfo: false,
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onBackordersSearch = async () => {
    try {
      const {
        online, setLoader, notify
      } = this.props;
      const searchData = {};
      if (this.state.selectedAccount.length > 0) {
        searchData.accountName = this.state.selectedAccount;
      }
      if (this.state.selectedCaseType.length > 0) {
        searchData.caseType = this.state.selectedCaseType;
      }
      if (this.state.selectedProduct.length > 0) {
        searchData.productNo = this.state.selectedProduct;
      }
      if (online) {
        setLoader(true);
        if (this.apiController) {
          this.apiController.abort();
        }
        this.apiController = initAPIController();
        getBackorders(searchData).then((res) => {
          setLoader(false);
          if (res.status) {
            if (res.data.length === 0 && Object.keys(searchData).length === 0) {
              this.setState({
                noRecords: true,
                updatedAt: moment().format('MM/DD/YY hh:mm A')
              });
              return;
            }
            if (res.data.length === 0) {
              this.setState({
                noRecords: false,
                updatedAt: moment().format('MM/DD/YY hh:mm A')
              });
              return;
            }
            const accountSet = new Set();
            let mostRecentUpdate = new Date(0);
            res.data.forEach((item) => {
              if (new Date(item.DateUpdated) > mostRecentUpdate) {
                mostRecentUpdate = item.DateUpdated;
              }
              accountSet.add(item.AccountName);
            });
            const sortedAccounts = Array.from(accountSet).sort();
            const backordersResult = {};
            sortedAccounts.forEach((account) => {
              const currentProductNos = new Set();
              const clearedProductNos = new Set();
              backordersResult[account] = {};
              backordersResult[account].current = [];
              backordersResult[account].cleared = [];

              res.data
                .filter((order) => (order.AccountName === account && order.ClearedDate === null))
                .forEach((currentOrder) => currentProductNos.add(currentOrder.ProductNo));
              res.data
                .filter((order) => (order.AccountName === account && order.ClearedDate !== null))
                .forEach((clearedOrder) => clearedProductNos.add(clearedOrder.ProductNo));

              Array.from(currentProductNos)
                .sort((a, b) => {
                  if (a < b) return -1;
                  return 1;
                })
                .forEach((productNo) => {
                  const productGroup = {};
                  productGroup.ProductNo = productNo;
                  productGroup.Qty = 0;
                  productGroup.Orders = res.data
                    .filter((order) => (order.AccountName === account
                      && order.ClearedDate === null
                      && order.ProductNo === productNo))
                    .sort((a, b) => {
                      if (a.OrderDate < b.OrderDate) return -1;
                      if (a.OrderDate > b.OrderDate) return 1;
                      return 0;
                    });

                  productGroup.Orders.forEach((order) => {
                    productGroup.Qty += parseInt(order.Qty, 10);
                    productGroup.ProductDescription = order.ProductDescription;
                  });

                  backordersResult[account].current.push(productGroup);
                });
              Array.from(clearedProductNos)
                .sort((a, b) => {
                  if (a < b) return -1;
                  return 1;
                })
                .forEach((productNo) => {
                  const productGroup = {};
                  productGroup.ProductNo = productNo;
                  productGroup.Qty = 0;
                  productGroup.Orders = res.data
                    .filter((order) => (order.AccountName === account
                      && order.ClearedDate !== null
                      && order.ProductNo === productNo));

                  productGroup.Orders.forEach((order) => {
                    productGroup.Qty += parseInt(order.Qty, 10);
                    productGroup.ProductDescription = order.ProductDescription;
                  });

                  backordersResult[account].cleared.push(productGroup);
                });
            });
            this.setState({
              accounts: sortedAccounts,
              backorders: backordersResult,
              noRecords: false,
              updatedAt: moment(mostRecentUpdate).format('MM/DD/YY hh:mm A'),
            });
          }
        }).catch((e) => {
          console.log(e);
        });
      } else {
        notify({
          type: 'error',
          message: 'You must have an internet connection. Please check your connection and try again.',
          time: 5
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickBackorders = (data) => {
    try {
      const { setOfficeSetsFilter } = this.props;
      const {
        backorders,
        selectedCaseType,
        isCaseType,
        selectedAccount,
        isAccount,
        selectedProduct,
        isProduct,
      } = this.state;
      setOfficeSetsFilter({
        backorders,
        selectedCaseType,
        isCaseType,
        selectedAccount,
        isAccount,
        selectedProduct,
        isProduct,
      });
      this._onGoBack();
      browserHistory.push(`/inventory/${encodeURIComponent(data.SetName)}/officeSets`);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  async UNSAFE_componentWillMount() {
    const { online, notify } = this.props;
    try {
      if (online) await this._onBackordersSearch();
      else {
        notify({
          type: 'error',
          message: 'You must have an internet connection. Please check your connection and try again.',
          time: 5
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render = () => {
    const { online, notify, setLoader } = this.props;
    const {
      updatedAt, accounts, backorders, selectedCaseType, isCaseType,
      selectedAccount, isAccount, selectedProduct, isProduct, isInfo,
      noRecords
    } = this.state;
    return (
      <section className="list-section">
        <Header
          title={isCaseType ? 'Type' : isAccount ? 'Account' : isProduct ? 'Product' : 'Backorders'}
          goBack={(isCaseType || isAccount || isProduct || isInfo)
            ? this._onBackordersBack : this._onGoBackSetInfo}
        />
        {
          !isInfo
            ? !isAccount
              ? !isProduct
                ? (!isCaseType)
                  ? (
                    <div className="container backorders-np">
                      <div
                        onClick={() => this.setState({ isInfo: true })}
                        style={{
                          position: 'fixed',
                          zIndex: 999999,
                          right: '6%',
                          top: 11,
                          cursor: 'pointer'
                        }}
                      >
                        <img
                          width="20px"
                          src={InfoIcon}
                          alt="info"
                        />
                      </div>

                      <section className="sets-section">
                        <div
                          className="sets-section-backorder"
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            paddingLeft: 8,
                            paddingRight: 8,
                            paddingTop: 8,
                            paddingBottom: 16,
                            position: 'sticky',
                            top: 45,
                            zIndex: 1000,
                            backgroundColor: '#212121'
                          }}
                        >
                          <span style={{ marginBottom: 8 }}>Updated: {updatedAt}</span>
                          <div>
                            <button
                              type="button"
                              className="btn btn-sm btn-theme-alt btn-theme-outline-alt"
                              style={{ padding: '2px 12px', marginRight: 4, fontWeight: 'normal' }}
                              onClick={this._onAccountClick}
                            >Account
                            </button>
                            <button
                              type="button"
                              className="btn btn-sm btn-theme-alt btn-theme-outline-alt"
                              style={{ padding: '2px 12px', fontWeight: 'normal' }}
                              onClick={this._onProductClick}
                            > Product
                            </button>
                            <button
                              type="button"
                              className="btn btn-sm btn-theme-alt btn-theme-outline-alt"
                              style={{ padding: '2px 20px', marginLeft: 4, fontWeight: 'normal' }}
                              onClick={this._onCaseTypeClick}
                            >
                              Type
                            </button>
                          </div>
                          <div className="button-scrollarea">
                            {
                              selectedAccount.map(
                                (account, i) => (
                                  <div
                                    key={`account-${i + 1}`}
                                    className="filterTag"
                                  >
                                    {account}
                                    <div
                                      style={{ marginLeft: 16, cursor: 'pointer' }}
                                      onClick={
                                        () => {
                                          const tempAccounts = selectedAccount;
                                          tempAccounts.splice(i, 1);
                                          this.setState({
                                            selectedAccount: tempAccounts
                                          }, this._onBackordersSearch);
                                        }
                                      }
                                    >
                                      x
                                    </div>
                                  </div>
                                )
                              )
                            }
                            {selectedProduct.map((product, i) => (
                              <div
                                key={`product-${i + 1}`}
                                className="filterTag"
                              >
                                {product}
                                <div
                                  onClick={() => {
                                    const tempProducts = selectedProduct;
                                    tempProducts.splice(i, 1);
                                    this.setState({
                                      selectedProduct: tempProducts
                                    }, this._onBackordersSearch);
                                  }}
                                  style={{ marginLeft: 16, cursor: 'pointer' }}
                                >
                                  x
                                </div>
                              </div>
                            ))}
                            {selectedCaseType.map((type, i) => (
                              <div
                                key={`type-${i + 1}`}
                                className="filterTag"
                              >
                                {type}
                                <div
                                  onClick={() => {
                                    const tempCaseTypes = selectedCaseType;
                                    tempCaseTypes.splice(i, 1);
                                    this.setState({
                                      selectedCaseType: tempCaseTypes
                                    }, this._onBackordersSearch);
                                  }}
                                  style={{ marginLeft: 16, cursor: 'pointer' }}
                                >
                                  x
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                        <div>
                          <div>
                            {
                              accounts.length > 0
                                ? accounts.map(
                                  (item, index) => (
                                    <div key={index}>
                                      <h4
                                        className="bg-label"
                                        style={{
                                          backgroundColor: '#0E120F',
                                          fontSize: 15,
                                          width: '100%',
                                          padding: '8px',
                                          position: 'sticky',
                                          top: selectedAccount.length > 0
                                            || selectedCaseType.length > 0
                                            || selectedProduct.length > 0 ? 158 : 124,
                                          marginBottom: 0,
                                          zIndex: 999,
                                        }}
                                      >
                                        {item}
                                      </h4>
                                      {
                                        backorders[item].current.length > 0 && (
                                          <div
                                            className="bg-theme"
                                            style={{
                                              paddingLeft: 8,
                                              color: '#A6A6A6',
                                              textDecorationLine: 'underline',
                                              fontSize: 12,
                                              position: 'sticky',
                                              top: selectedAccount.length > 0
                                                || selectedCaseType.length > 0
                                                || selectedProduct.length > 0 ? 192 : 158,
                                              backgroundColor: '#212121',
                                              paddingTop: 4,
                                              paddingBottom: 4,
                                            }}
                                          >
                                            CURRENT BACKORDERS
                                          </div>
                                        )
                                      }
                                      {
                                        backorders[item].current.map((accountOrder, i) => (
                                          <div key={`${index}-${i + 1}`}>
                                            <div
                                              data-bs-toggle="collapse"
                                              data-bs-target={`#collapse${index}-${i + 1}`}
                                              style={{ display: 'flex', padding: '4px 8px' }}
                                            >
                                              <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                                                <div>{accountOrder.ProductNo}</div>
                                                <div>{accountOrder.ProductDescription}</div>
                                              </div>
                                              <div
                                                className="btn-collapse collapsed"
                                                data-bs-toggle="collapse"
                                                data-bs-target={`#collapse${index}-${i + 1}`}
                                                aria-expanded="false"
                                                style={{ marginRight: 8 }}
                                              >
                                                <i className="fas fa-chevron-down" style={{ color: '#eda340' }} />
                                              </div>
                                              <div style={{ minWidth: 60, whiteSpace: 'nowrap' }}>Qty: -{accountOrder.Qty}</div>
                                            </div>
                                            <div className="collapse" id={`collapse${index}-${i + 1}`}>
                                              <div
                                                className="bg-card"
                                                style={{
                                                  width: '100%',
                                                  marginBottom: 2,
                                                  backgroundColor: '#424242',
                                                  padding: '2px 10px'
                                                }}
                                              >
                                                <table style={{ width: '100%' }}>
                                                  <tbody>
                                                    <tr>
                                                      <td className="col-3" style={{ textAlign: 'left', fontSize: 12, color: '#A6A6A6' }}>Order Date</td>
                                                      <td className="col-3" style={{ textAlign: 'center', fontSize: 12, color: '#A6A6A6' }}>Order#</td>
                                                      <td className="col-3" style={{ textAlign: 'center', fontSize: 12, color: '#A6A6A6' }}>BO Qty</td>
                                                      <td className="col-3" style={{ textAlign: 'right', fontSize: 12, color: '#A6A6A6' }}>BO Days</td>
                                                    </tr>
                                                    {
                                                      accountOrder.Orders.map((order, j) => (
                                                        <tr key={`order-${j + 1}`}>
                                                          <td style={{ fontSize: 12 }}>{moment(order.OrderDate).format('MM/DD/YY')}</td>
                                                          <td style={{ textAlign: 'center', fontSize: 12 }}>{order.OrderNo}</td>
                                                          <td style={{ textAlign: 'center', fontSize: 12 }}>{order.Qty}</td>
                                                          <td style={{ textAlign: 'right', fontSize: 12, paddingRight: 20 }}>{order.BODays}</td>
                                                        </tr>
                                                      ))
                                                    }
                                                  </tbody>
                                                </table>
                                              </div>
                                            </div>
                                          </div>
                                        ))
                                      }
                                      {
                                        backorders[item].cleared.length > 0 && (
                                          <div style={{
                                            position: 'sticky',
                                            top: selectedAccount.length > 0
                                              || selectedCaseType.length > 0
                                              || selectedProduct.length > 0 ? 182 : 148
                                          }}
                                          >
                                            <div
                                              className="bd-b-gray"
                                              style={{
                                                width: '100%',
                                                height: 10,
                                                borderBottom: '2px solid #424242',
                                              }}
                                            />
                                            <div
                                              className="bg-theme"
                                              style={{
                                                display: 'flex',
                                                width: '100%',
                                                backgroundColor: '#212121',
                                                paddingTop: 4,
                                                paddingBottom: 4,
                                              }}
                                            >
                                              <div
                                                style={{
                                                  paddingLeft: 8,
                                                  marginRight: 2,
                                                  whiteSpace: 'nowrap',
                                                  color: '#A6A6A6',
                                                  textDecorationLine: 'underline',
                                                  fontSize: 12,
                                                }}
                                              >CLEARED BACKORDERS
                                              </div>
                                            </div>
                                          </div>
                                        )
                                      }
                                      {
                                        backorders[item].cleared
                                          .map((accountOrder, i) => (
                                            <div key={`${index}-${i + 1}`}>
                                              <div
                                                data-bs-toggle="collapse"
                                                data-bs-target={`#collapse${index}-${i + 1}-${i + 1}`}
                                                style={{ display: 'flex', padding: '4px 8px' }}
                                              >
                                                <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                                                  <div>{accountOrder.ProductNo}</div>
                                                  <div>{accountOrder.ProductDescription}</div>
                                                </div>
                                                <div
                                                  className="btn-collapse collapsed"
                                                  data-bs-toggle="collapse"
                                                  data-bs-target={`#collapse${index}-${i + 1}-${i + 1}`}
                                                  aria-expanded="false"
                                                  style={{ marginRight: 8 }}
                                                >
                                                  <i className="fas fa-chevron-down" style={{ color: '#eda340' }} />
                                                </div>
                                                <div style={{ minWidth: 60, whiteSpace: 'nowrap' }}>Qty: {accountOrder.Qty}</div>
                                              </div>
                                              <div className="collapse" id={`collapse${index}-${i + 1}-${i + 1}`}>
                                                <div
                                                  className="bg-card"
                                                  style={{
                                                    width: '100%',
                                                    marginBottom: 2,
                                                    backgroundColor: '#424242',
                                                    padding: '2px 10px'
                                                  }}
                                                >
                                                  <table style={{ width: '100%' }}>
                                                    <tbody>
                                                      <tr>
                                                        <td className="col-3" style={{ textAlign: 'left', fontSize: 12, color: '#A6A6A6' }}>Order Date</td>
                                                        <td className="col-3" style={{ textAlign: 'center', fontSize: 12, color: '#A6A6A6' }}>Order#</td>
                                                        <td className="col-3" style={{ textAlign: 'center', fontSize: 12, color: '#A6A6A6' }}>BO Qty</td>
                                                        <td className="col-3" style={{ textAlign: 'right', fontSize: 12, color: '#A6A6A6' }}>Cleared Date</td>
                                                      </tr>
                                                      {accountOrder.Orders
                                                        .map((order, j) => (
                                                          <tr key={`order-${j + 1}`}>
                                                            <td style={{ fontSize: 12 }}>{moment(order.OrderDate).format('MM/DD/YY')}</td>
                                                            <td style={{ textAlign: 'center', fontSize: 12 }}>{order.OrderNo}</td>
                                                            <td style={{ textAlign: 'center', fontSize: 12 }}>{order.Qty}</td>
                                                            <td style={{ textAlign: 'right', fontSize: 12, paddingRight: 10 }}>{moment(order.ClearedDate).format('MM/DD/YY')}</td>
                                                          </tr>
                                                        ))}
                                                    </tbody>
                                                  </table>
                                                </div>
                                              </div>
                                            </div>
                                          ))
                                      }
                                    </div>
                                  )
                                )
                                : noRecords
                                  ? <p className="text-center">No backorders are currently recorded for your team</p>
                                  : <p className="text-center">No sets match to your filters</p>
                            }
                          </div>

                        </div>
                      </section>
                    </div>
                  )
                  : (
                    <BackordersCaseTypes
                      selectedCaseType={selectedCaseType}
                      selectedProduct={selectedProduct}
                      selectedAccount={selectedAccount}
                      onSelectedCaseType={this._onSelectedCaseType}
                      onBackFromFilters={this._onBackordersBack}
                      online={online}
                      notify={notify}
                      setLoader={setLoader}
                    />
                  )
                : (
                  <BackordersProducts
                    selectedCaseType={selectedCaseType}
                    selectedProduct={selectedProduct}
                    selectedAccount={selectedAccount}
                    onSelectedProduct={this._onSelectedProduct}
                    onBackFromFilters={this._onBackordersBack}
                    online={online}
                    notify={notify}
                    setLoader={setLoader}
                  />
                ) : (
                  <BackordersAccounts
                    selectedCaseType={selectedCaseType}
                    selectedProduct={selectedProduct}
                    selectedAccount={selectedAccount}
                    onSelectedAccount={this._onSelectedAccount}
                    onBackFromFilters={this._onBackordersBack}
                    online={online}
                    notify={notify}
                    setLoader={setLoader}
                  />
              ) : (
                <div className="container">
                  <div className="row">
                    <div className="col-12">
                      <div style={{ padding: '32px 16px' }}>
                        <div>
                          1. Due to the movement of product between accounts, the
                          backorder location data is approximate. You should physically verify
                          your consignment products prior to any surgery.
                        </div>
                        <div style={{ marginTop: 16 }}>
                          2. Most cleared backorders have shipped. However, some may have
                          been canceled in the system. Check with your office if you have
                          any questions.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            )
        }
      </section>
    );
  }
}

export default withOfficeSetsFilter(
  withSetsSearch(
    withOnline(
      withGoBack(
        withNotify(
          withLoader(
            Backorders
          )
        )
      )
    )
  )
);
